export default __webpack_public_path__ + "01c109450d114d733e30f3a1d8f0b362.png";